import {ref} from "vue";
import type {ChatState} from "./ChatState.js";
import type {SessionItem} from "../session/SessionItem.js";
import {MessageFactory} from "../factory/MessageFactory.js";
import SSEClient from "../SSEComponent/SSEClient.js";
import {MCFCopilotSSEAdapter} from "../SSEComponent/MCFCopilotSSEAdapter.js";
import type {MessageStateMachine} from "./MessageStateMachine.js";
import type {OnSSEConnectListener} from "../listener/OnSSEConnectListener.js";

export class SearchState implements ChatState {

    constructor(private machine: MessageStateMachine) {}

    async handler(text: string, session: SessionItem) {

        const machine = this.machine
        const msg = ref(MessageFactory.createAiMsg())
        msg.value.isStreaming = true
        session.pushMessage(msg.value)

        const url = new URL("/api/mcframeAI/dev", window.location.origin)
        url.searchParams.set("question", text)

        const sseClient = new SSEClient(url)
        this.machine.sseClient = sseClient
        sseClient.registerAdapter(new MCFCopilotSSEAdapter(session))
        sseClient.registerConnectionListener(new class implements OnSSEConnectListener {
            onClose(): void {
                machine.isChatting = false
            }

            onSSEConnect(): void {
                machine.isChatting = true
            }

        })
        sseClient.connect()

    }

}